import React from 'react'
import {BsLinkedin} from 'react-icons/bs'
import {FaGithub} from 'react-icons/fa'

const HeaderSocials = () => {
  return (
    <div className="header_socials">
        <a href="https://linkedin.com" target={'_blank'}><BsLinkedin/></a>
        <a href="https://github.com/ahmadmjkhan?tab=repositories" target={'_blank'}><FaGithub/></a>
        
    </div>
  )
}

export default HeaderSocials